/**
 * The one live region the app announces page changes through.
 *
 * It is created on <body>, OUTSIDE Inertia's #app root, on purpose: every page
 * swap unmounts the whole React tree, so a region living inside it would be
 * destroyed and re-created together with its text — which is precisely the
 * pattern screen readers skip. A node that was already in the accessibility
 * tree before its content changed is the only one reliably announced.
 */
const REGION_ID = 'page-announcer'

function region() {
  if (typeof document === 'undefined') return null

  const existing = document.getElementById(REGION_ID)
  if (existing) return existing

  const node = document.createElement('div')
  node.id = REGION_ID
  node.setAttribute('role', 'status')
  node.setAttribute('aria-live', 'polite')
  node.className = 'sr-only'
  document.body.appendChild(node)

  return node
}

export function announce(message: string) {
  const node = region()
  if (!node) return

  // The same string twice running is not a content *change*, so nothing would
  // be spoken the second time — clear it, then write on the next frame.
  node.textContent = ''
  requestAnimationFrame(() => {
    node.textContent = message
  })
}
